// ============================================================================
//  AYUSH & ZEEL — WEDDING INVITATION · SINGLE SOURCE OF TRUTH
//  Every piece of text and every image on the site is read from this object.
//
//  TO DROP IN YOUR AI-GENERATED ILLUSTRATIONS:
//  1. Place the image files in /frontend/public/images/
//  2. Set the matching `image` field below, e.g. "/images/hero-couple.png"
//  Leave a field as `null` to keep the elegant AZ monogram placeholder.
// ============================================================================

export const weddingConfig = {
  couple: {
    firstName: "Ayush",
    secondName: "Zeel",
    initials: "AZ",
    firstParents: "S/O Bhawani Sahu and Shobha Sahu",
    secondParents: "D/O Deepak Jain and Seema Jain",
  },

  seal: {
    eyebrow: "A Wedding Invitation",
  },

  hero: {
    caption: "Together Forever",
    joiner: "and",
    dateLine: "11–12 December",
    locationLine: "Jabalpur",
    // Live countdown target — wedding ceremony start (IST).
    countdownTarget: "2026-12-12T14:00:00+05:30",
    countdownLabel: "Counting down to the big day",

    // ── IMAGE SLOT 1 · HERO AVATAR ─────────────────────────────────────────
    // Couple embracing in traditional wedding attire.
    image: "/images/hero-couple.jpg",
    imageAlt:
      "Illustration of Ayush and Zeel embracing in traditional wedding attire",
    placeholderLabel: "Hero illustration",
  },

  marquee: ["Ayush & Zeel", "11–12 December", "Jabalpur"],

  music: {
    // Drop the track file at /frontend/public/music/jahaan.mp3 — it starts
    // playing automatically once the invitation is opened.
    src: "/music/jahaan.mp3",
  },

  itinerary: {
    eyebrow: "The Celebrations",
    heading: "Itinerary",
    venueNote: "All events at Park Inn by Radisson, Jabalpur",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Park+Inn+by+Radisson+Jabalpur",
    venueHint: "Tap to open the location",
    events: [
      {
        id: "tilak",
        name: "Faldan Ceremony",
        date: "11 December",
        time: "10:00 AM",
        venue: "Park Inn by Radisson, Jabalpur",
        // ── IMAGE SLOT 2 · FALDAN CEREMONY AVATAR ──
        image: "/images/tilak.jpg",
        imageAlt: "Illustration of the couple in Faldan ceremony attire",
        placeholderLabel: "Faldan illustration",
        // colour burst palette for the event popup
        colors: ["#FB7185", "#FBBF24", "#F472B6", "#34D399"],
      },
      {
        id: "haldi",
        name: "Haldi Carnival",
        date: "11 December",
        time: "2:00 PM",
        venue: "Park Inn by Radisson, Jabalpur",
        // ── IMAGE SLOT 3 · HALDI CARNIVAL AVATAR ──
        image: "/images/haldi.jpg",
        imageAlt: "Illustration of the couple in Haldi carnival attire",
        placeholderLabel: "Haldi illustration",
        colors: ["#FDE047", "#FB923C", "#F59E0B", "#FEF08A"],
      },
      {
        id: "sangeet",
        name: "Engagement & Sangeet",
        date: "11 December",
        time: "7:00 PM",
        venue: "Park Inn by Radisson, Jabalpur",
        // ── IMAGE SLOT 4 · ENGAGEMENT & SANGEET AVATAR ──
        image: "/images/sangeet.jpg",
        imageAlt: "Illustration of the couple in Engagement and Sangeet attire",
        placeholderLabel: "Sangeet illustration",
        colors: ["#818CF8", "#38BDF8", "#E879F9", "#C084FC"],
      },
      {
        id: "wedding",
        name: "Wedding Ceremony",
        date: "12 December",
        time: "2:00 PM",
        venue: "Park Inn by Radisson, Jabalpur",
        // ── IMAGE SLOT 5 · WEDDING CEREMONY AVATAR ──
        image: "/images/wedding.jpg",
        imageAlt: "Illustration of the couple in wedding ceremony attire",
        placeholderLabel: "Wedding illustration",
        colors: ["#F87171", "#FBBF24", "#FCA5A5", "#FDE68A"],
      },
    ],
  },

  footer: {
    closingLine: "We can't wait to celebrate with you",
    note: "11–12 December · Jabalpur",
  },

  meta: {
    siteName: "Ayush & Zeel",
    title: "Ayush & Zeel — Wedding Invitation",
    description:
      "Ayush & Zeel invite you to celebrate their wedding — 11–12 December, Jabalpur. Tap the seal to open the invitation.",
  },
};
